import { useTranslate } from "@tolgee/react";
import { InfoTooltip } from "#/components/ui/info-tooltip";
import type { AccountInfoMetric } from "./types/account-info.types.ts";

type AccountInfoSectionProps = {
	title: string;
	metrics: AccountInfoMetric[];
};

export function AccountInfoSection({
	title,
	metrics,
}: AccountInfoSectionProps) {
	const { t } = useTranslate();
	return (
		<div className="space-y-2">
			<div className="text-body2-bold text-trade-text-strong">
				{title}
			</div>
			<div className="space-y-1.5">
				{metrics.map((metric) => (
					<div
						key={metric.label}
						className="flex items-center justify-between gap-4 text-label1"
					>
						{metric.tooltip ? (
							<InfoTooltip
								content={t(metric.tooltip)}
								className="text-trade-text-secondary"
							>
								{t(metric.label)}
							</InfoTooltip>
						) : (
							<span className="text-trade-text-secondary">
								{t(metric.label)}
							</span>
						)}
						<span
							className={`text-label1-medium text-trade-text-strong ${metric.valueClassName ?? ""}`}
						>
							{metric.value}
						</span>
					</div>
				))}
			</div>
		</div>
	);
}
